<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <div class="main-content">
          <el-row>
            <el-col :span="12">
              <div>
                <div>
                  <div class="title three">公&nbsp;司&nbsp;名:</div>
                  <div class="desc">{{obj.name}}</div>
                </div>
                <div>
                  <div class="title">公司账户:</div>
                  <div class="desc">{{obj.account}}</div>
                </div>
                <div>
                  <div class="title three">开&nbsp;户&nbsp;行:</div>
                  <div class="desc">{{obj.bank}}</div>
                </div>
                <div>
                  <div class="title three">开&nbsp;户&nbsp;名:</div>
                  <div class="desc">{{obj.bank_name}}</div>
                </div>
                <div>
                  <div class="title"> 公司余额:</div>
                  <div class="descLast">{{obj.blance_money}}</div>
                </div>
<!--                <div class="last-item">-->
<!--                  <div class="title"> 可用余额预警:</div>-->
<!--                  <div class="switch">-->
<!--                    <el-switch-->
<!--                      v-model="value"-->
<!--                      @change="changeSwitch"-->
<!--                      active-color="#13ce66"-->
<!--                      inactive-color="#ccc">-->
<!--                    </el-switch>-->
<!--                  </div>-->
<!--                  <div class="early-warning" v-show="isShow">-->
<!--                    <div>（预警阀值为</div>-->
<!--                    <i class="iconfont iconjine iconprice"></i>-->
<!--                    {{ this.balancePrice }}-->
<!--                    <el-button type="text" class="update-btn" @click="update">修改</el-button>-->
<!--                    <div>）</div>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </el-col>
            <el-col :span="12" >
              <div class="info">
                <div v-if="obj.company_rate !== 0">
                  <div class="title tax" >
                    服务费率:
                  </div>
                  <div class="descOne">
                    {{obj.company_rate}}%
                  </div>
                </div>
                <div>
                  <div class="title">
                    打款户名:
                  </div>
                  <div class="desc">
                   {{obj.trade_channel_account}}
                  </div>
                </div>
                <div>
                  <div class="title">
                    打款账户:
                  </div>
                  <div class="desc">
                    {{obj.trade_account}}
                  </div>
                </div>
                <div>
                  <div class="title">
                    打款开户行:
                  </div>
                  <div class="desc">
                    <!-- {{obj.trade_uid}} -->
                    {{ this.bankOfDeposit }}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose" :showButton="showButton" >
          <template slot="content">
            <div class="price-wrapper">
              <el-alert
                class="warning-tips"
                :type="'warning'"
                :show-icon="true"
                :closable="false">
                  <template name="—">
                    <span>
                      <div>设置金额小于阀值，系统将每天发送一次通知</div>
                    </span>
                  </template>
              </el-alert>
              <el-form :model="formData" :rules="rules" ref="priceForm" label-width="95px" class="price-form">
                <el-form-item label="预警金额" prop="price">
                  <el-input placeholder="请输入金额" v-model="formData.price" type="number">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </ModalDialog>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ModalDialog from '@/components/ModalDialog'

export default {
  components: {
    PageHeaderLayout,
    ModalDialog,
  },
  data() {
    return {
      bankOfDeposit: '',
      showButton: ['cancel'],
      obj: {},
      value: false,
      dialogData:{
        visible: false,
        title: '设置额度',
        width: '35%',
        loading: true,
        modal: false
      },
      formData: {
        price: ''
      },
      rules: {
        price: [
          { required: true, message: '请输入修改金额', trigger: 'blur' },
        ],
      },
      balancePrice: '',
      isShow: false,
    }
  },
  watch: {
    "formData.price": function(val) {
      if(val) {
        this.dialogData.loading = false
      }
    }
  },
  methods: {
    //获取账号信息
    async getInfo() {
      let info = await this.$api.getAccountInfo()
      this.companyId = info.id
      this.balancePrice = info.warning_money
      this.bankOfDeposit = info.trade_bank
      if(info.is_warning == 1) {
        this.value = true
        this.isShow = true
      }
      if(info.is_warning == 0) {
        this.value = false
        this.isShow = false
      }
      this.obj= info
      let companyIds = this.$config.domain?.settlmentlCustom?.companyIds||[]
      companyIds.forEach(item => {
        if(this.companyId == item) {
          if(this.obj.trade_channel_account == this.$config.domain.settlmentlCustom.originName) {
            this.obj.trade_account = this.$config.domain.settlmentlCustom.paymentAccount
            this.bankOfDeposit = this.$config.domain.settlmentlCustom.bankOfDeposit
            this.obj.trade_channel_account = this.$config.domain.settlmentlCustom.currentName
            this.obj.company_rate = this.$config.domain.settlmentlCustom.taxRate
          }
        } 
      }) 
    },
    //修改预警金额
    update() {
      this.dialogData.visible = true
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['priceForm'].validate((valid) => {
        if (valid) {
          this.balancePrice = this.formData.price
          console.log(this.balancePrice,"this.formData.price")
          this.dialogData.visible = false
          this.formData = {}
          let data = {
            is_warning: 1,
            warning_money: this.balancePrice
          }
          this.changeWarning (data, "price")
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    //关闭设置阀值弹窗
    dialogClose() {
      this.dialogData.visible = false
      this.formData = {}
    },
    //switch按钮改变触发函数
    changeSwitch() {
      console.log(this.value,"changeSwitch->value")
      if(this.value) {
        let data = {
          is_warning: 1,
          warning_money: this.balancePrice
        }
        this.changeWarning(data, "switch")
        this.isShow = true
      }else {
        let data = {
          is_warning: 0,
          warning_money: this.balancePrice
        }
        this.changeWarning(data, "switch")
        this.isShow = false
      }
    },
    async changeWarning(data, type) {
      console.log(data)
      let result = await this.$api.changeWarning(data)
      if(result) {
        if(type == "switch") {
          this.$message.success('余额预警开启')
        }
        if(type == "price") {
          this.$message.success('保存成功')
        }
      }else {
        if(type == "switch") {
          this.$message.error('余额预警关闭')
        }
        if(type == "price") {
          this.$message.error('保存失败')
        }
      }
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="stylus" scoped>
  .title
    height: 45px
    color: rgba(97, 94, 94, 1)
    font-size: 18px
    line-height: 65px
  .main-content
    width: 980px
    margin: 50px
  .desc,
  .descOne
    color: rgba(28, 16, 1, 1)
    font-size: 18px
    text-align: left
    margin-left: 100px
  .desc
    height: 59px
    line-height: 59px
  .descOne
    height: 163px
    line-height 120px
    left: 1066px
    color: rgba(255, 149, 2, 1)
    font-size: 72px
  .descLast
    color: rgba(28, 16, 1, 1)
    font-size: 72px
    margin-left: 100px
  .tax
    word-spacing: 25px
  .three
    word-spacing: 5px
  .info
    float: right
  .last-item
    display: flex
    margin-top: 50px
  .switch
    margin-left: 15px
    line-height: 65px
  .early-warning
    line-height: 65px
    display: flex
  .update-btn
    margin-left: 10px
    margin-top: -4px
  .price-wrapper
    display: flex
    justify-content: center
    flex-direction: column
  .iconprice
    color: #e6a23c
    font-size: 25px
    margin-top: 2px
  .warning-tips
    padding: 15px 20px
    font-size: 16px
  .price-form
    margin: 50px 35px 0
  /deep/.price-wrapper .el-alert--warning.is-light .el-alert__description
    font-size: 15px
    margin-top: -2px
</style>
